import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  pointer: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
    },
  },
}));

const UserNavbar = ({ User, role, isUserNavbar }) => {
  const classes = useStyles();
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light bg-light py-0 border-bottom ${
        isUserNavbar !== true ? 'd-none' : 'd-block'
      }`}
      id="user-navbar"
    >
      <div>
        <div className="navbar-nav position-relative">
         {localStorage.getItem('me') != null && localStorage.getItem('me').indexOf("@") === -1? (
         <a
            className={`nav-link ${classes.pointer} ${
              window.location.pathname === '/sub' ? ' active' : ''
            }`}
            href="/sub"
          >
            Sub
          </a>
          ) : null}
          {role === 'COMPANY' || (User.agentType != null && User.agentType === 'COMPANY') ? (
            <a
              className={`nav-link ${classes.pointer} ${
                window.location.pathname === '/vendor' ? ' active' : ''
              }`}
              href="/vendor"
            >
              Vendor
            </a>
          ) : null}
          {role === 'COMPANY' || role === 'VENDOR' || (User.agentType != null && (User.agentType === 'COMPANY' || User.agentType === 'VENDOR'))? (
            <a
              className={`nav-link ${classes.pointer} ${
                window.location.pathname === '/senior' ? ' active' : ''
              }`}
              href="/senior"
            >
              Senior
            </a>
          ) : null}
          {role === 'COMPANY' || role === 'VENDOR' || role === 'SENIOR' || (User.agentType != null && (User.agentType === 'COMPANY' || User.agentType === 'VENDOR' || User.agentType === 'SENIOR')) ? (
            <a
              className={`nav-link ${classes.pointer} ${
                window.location.pathname === '/master' ? ' active' : ''
              }`}
              href="/master"
            >
              Master
            </a>
          ) : null}
          {role === 'COMPANY' || role === 'VENDOR' || role === 'SENIOR' ||role === 'MASTER' || 
          (User.agentType != null && (User.agentType === 'COMPANY' || User.agentType === 'VENDOR' || User.agentType === 'SENIOR' || User.agentType === 'MASTER')) ? (
            <a
              className={`nav-link ${classes.pointer} ${
                window.location.pathname === '/agent' ? ' active' : ''
              }`}
              href="/agent"
            >
              Agent
            </a>
          ) : null}
          <a
            className={`nav-link ${classes.pointer} ${
              window.location.pathname === '/member' ? ' active' : ''
            }`}
            href="/member"
          >
            Member
          </a>
        </div>
      </div>
    </nav>
  );
};

export default UserNavbar;
